import React from 'react';

import {
  Section,
  UsefulLinks,
} from 'features/order-tracker/shared-components';

import {
  HELPFUL_LINKS_SECTION_TITLE,
  USEFUL_LINKS,
} from './constants';

import styles from './styles.module.scss';

export const UsefulLinksSection: React.FC = () => (
  <Section>
    <h3 className={styles.sectionTitle}>{HELPFUL_LINKS_SECTION_TITLE}</h3>
    <UsefulLinks links={USEFUL_LINKS} />
  </Section>
);
